import * as React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import Modal from '@mui/material/Modal';
import axios from "axios";
import baseUrlApi from '../../lib/baseUrlApi';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import SensorSettingModalDelete from "./SensorSettingModalDelete";
import { SensorConfigInputs } from "../../Consts/typs";
import { ApiRequest } from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';
import { useNavigate } from "react-router-dom";

type SensorSettingEditInputs = {
    sensorId: string;
    sensorName: string;
    isAdCalc: string;
    config: [
        {
            upThrehold: string;
            lowThrehold: string;
        }
    ],
    graph: {
        scaleY: string;
        scaleX: string;
    };
    mail: {
        isSend: boolean,
        sendSpan: string
    },
    comment: string;
};

interface SensorSettingProps {
    item: SensorConfigInputs;
    sensorId: string;
    sensorRecno: number;
    sensorName: string;
    sensorKind: number;
    childKind: number;
    lowThrehold: number;
    lowlowThrehold: number;
    upThrehold: number;
    upupThrehold: number;

    xScale: number;
    yScale: number;
    yMin: number;
    yMax: number;
    xRange: number;

    comment: string;
    isSend: boolean;
    sendSpan: string;
    minAnalog: string;
    maxAnalog: string;
    minDigital: string;
    maxDigital: string;

    setState: Function;
};

export default function SensorSettingModalEdit(props: SensorSettingProps) {
    // 各値の初期化
    const [sensorId, setSensorId] = useState<string>(props.sensorId);
    const [sensorRecno, setSensorRecno] = useState<number>(props.sensorRecno);
    const [sensorKind, setSensorKind] = useState<number>(props.sensorKind);
    const [lowThrehold, setLowThrehold] = useState<number>(props.lowThrehold);
    const [lowlowThrehold, setLowlowThrehold] = useState<number>(props.lowlowThrehold);
    const [upThrehold, setUpThrehold] = useState<number>(props.upThrehold);
    const [upupThrehold, setUpupThrehold] = useState<number>(props.upupThrehold);

    const [sensorName, setSensorName] = useState<string>(props.sensorName);
    const [minAnalog, setMinAnalog] = useState<string>(props.minAnalog);
    const [maxAnalog, setMaxAnalog] = useState<string>(props.maxAnalog);
    const [minDigital, setMinDigital] = useState<string>(props.minDigital);
    const [maxDigital, setMaxDigital] = useState<string>(props.maxDigital);

    const [strLowThrehold, setStrLowThrehold] = useState<string>(String(lowThrehold));
    const [strLowlowThrehold, setStrLowlowThrehold] = useState<string>(String(lowlowThrehold));
    const [strUpThrehold, setStrUpThrehold] = useState<string>(String(upThrehold));
    const [strUpupThrehold, setStrUpupThrehold] = useState<string>(String(upupThrehold));

    const [yScale, setYScale] = useState<number>(props.yScale);
    const [xScale, setXScale] = useState<number>(props.xScale);
    const [xRange, setXRange] = useState<number>(props.xRange);
    const [yMin, setYMin] = useState<number>(props.yMin);
    const [yMax, setYMax] = useState<number>(props.yMax);

    const [strYScale, setStrYScale] = useState<string>(yScale ? String(yScale) : "");
    const [strXScale, setStrXScale] = useState<string>(xScale ? String(xScale) : "");
    const [strXRange, setStrXRange] = useState<string>(xRange ? String(xRange) : "");
    const [strYMin, setStrYMin] = useState<string>(yMin ? String(yMin) : "");
    const [strYMax, setStrYMax] = useState<string>(yMax ? String(yMax) : "");

    const [childKind, setChildKind] = useState<number>(props.childKind);
    const [comment, setComment] = useState<string>(props.comment);
    const [sendSpan, setSendSpan] = useState<string>(props.sendSpan);
    const [error, setError] = useState<[]>([]);

    const [isSend, setIsSend] = useState<boolean>(true);

    const [open, setOpen] = React.useState(false);
    const [sensorSettingData, setSensorSettingData] = useState<SensorSettingEditInputs[]>([]);
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm<SensorSettingEditInputs>();

    const resetData = async () => {
        console.log(".........");
        console.log(props.sensorName);
        setSensorName(props.sensorName);
        setSensorKind(props.sensorKind);
        setChildKind(Number(props.childKind));
        if (props.childKind === 6) {
            console.log(wbgtStatusId);
            console.log(wbgtStatusId2);
            if (wbgtStatusId === 1) {
                setStrUpThrehold(String("31.00"));
            }
            if (wbgtStatusId2 === 1) {
                setStrUpupThrehold(String("31.00"));
            }
            if (wbgtStatusId === 2) {
                setStrUpThrehold(String("28.00"));
            }
            if (wbgtStatusId2 === 2) {
                setStrUpupThrehold(String("28.00"));
            }
            if (wbgtStatusId === 3) {
                setStrUpThrehold(String("25.00"));
            }
            if (wbgtStatusId2 === 3) {
                setStrUpupThrehold(String("25.00"));
            }
            if (wbgtStatusId === 4) {
                setStrUpThrehold(String("21.00"));
            }
            if (wbgtStatusId2 === 4) {
                setStrUpupThrehold(String("21.00"));
            }
            if (wbgtStatusId === 5) {
                setStrUpThrehold(String("-100.00"));
            }
            if (wbgtStatusId2 === 5) {
                setStrUpupThrehold(String("-100.00"));
            }
        } else {
            setStrUpupThrehold(String(props.upupThrehold));
            setStrUpThrehold(String(props.upThrehold));
        }
        setStrLowThrehold(String(props.lowThrehold));
        setStrLowlowThrehold(String(props.lowlowThrehold));
        setStrYMin(props.yScale ? String(props.yMin) : "");
        setStrYMax(props.yScale ? String(props.yMax) : "");
        setStrYScale(props.yScale ? String(props.yScale) : "");
        setStrXRange(props.xRange ? String(props.xRange) : "");
        setStrXScale(props.xScale ? String(props.xScale) : "");
        setMinAnalog(props.minAnalog ? String(props.minAnalog) : "");
        setMaxAnalog(props.maxAnalog ? String(props.maxAnalog) : "");
        setMinDigital(props.minDigital ? String(props.minDigital) : "");
        setMaxDigital(props.maxDigital ? String(props.maxDigital) : "");
        setIsSend(props.isSend);
        setSendSpan(props.sendSpan);
        setComment(props.comment);
        setError([]);
    };

    const handleOpen = async () => {
        resetData();
        setOpen(true);
    }

    const handleClose = async () => {
        resetData();
        setOpen(false);
    }

    function errorCallback(error: any) {
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', { path: '/' });
            removeCookie('authority', { path: '/' });
            removeCookie('siteId', { path: '/' });
            removeCookie('siteRecno', { path: '/' });
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const [wbgtStatusId, setWbgtStatusId] = useState(upThrehold == 31.00 ? 1: upThrehold == 28.00 ? 2: upThrehold == 25.00 ? 3:upThrehold == 21.00 ? 4:upThrehold == -100.00 ? 5:0);

    function updateWbgtStatusId(wbgtStatusId: number) {
        console.log("wbgtStatusId:", wbgtStatusId);
        setWbgtStatusId(wbgtStatusId);
        if (wbgtStatusId === 0) {
            setStrUpThrehold(String(null));
        }
        if (wbgtStatusId === 1) {
            setStrUpThrehold(String("31.00"));
        }
        if (wbgtStatusId === 2) {
            setStrUpThrehold(String("28.00"));
        }
        if (wbgtStatusId === 3) {
            setStrUpThrehold(String("25.00"));
        }
        if (wbgtStatusId === 4) {
            setStrUpThrehold(String("21.00"));
        }
        if (wbgtStatusId === 5) {
            setStrUpThrehold(String("-100.00"));
        }
        return wbgtStatusId;
    }

    const [wbgtStatusId2, setWbgtStatusId2] = useState(upupThrehold == 31.00 ? 1: upupThrehold == 28.00 ? 2: upupThrehold == 25.00 ? 3:upupThrehold == 21.00 ? 4:upupThrehold == -100.00 ? 5:0); 

    function updateWbgtStatusId2(wbgtStatusId2: number) {
        console.log("wbgtStatusId2:", wbgtStatusId2);
        setWbgtStatusId2(wbgtStatusId2);
        if (wbgtStatusId2 === 0) {
            setStrUpupThrehold(String("0.00"));
        }
        if (wbgtStatusId2 === 1) {
            setStrUpupThrehold(String("31.00"));
        }
        if (wbgtStatusId2 === 2) {
            setStrUpupThrehold(String("28.00"));
        }
        if (wbgtStatusId2 === 3) {
            setStrUpupThrehold(String("25.00"));
        }
        if (wbgtStatusId2 === 4) {
            setStrUpupThrehold(String("21.00"));
        }
        if (wbgtStatusId2 === 5) {
            setStrUpupThrehold(String("-100.00"));
        }
        return wbgtStatusId2;
    }

    const onSubmit: SubmitHandler<SensorSettingEditInputs> = async (data) => {
        try {
            const isAdCalc = sensorKind === 1 ? true : false;

            const params = {
                "prcKind": 1,
                "sensorRecno": sensorRecno,
                "sensorId": sensorId,
                "sensorName": sensorName,
                "sensorKind": sensorKind,
                "childKind": childKind,
                "waterConfig": {},
                "config":
                {
                    "upupThrehold": strUpupThrehold.trim() == "" ? null : Number(strUpupThrehold),
                    "upThrehold": strUpThrehold.trim() == "" ? null : Number(strUpThrehold),
                    "lowThrehold": strLowThrehold.trim() == "" ? null : Number(strLowThrehold),
                    "lowlowThrehold": strLowlowThrehold.trim() == "" ? null : Number(strLowlowThrehold)
                },
                "graph": {
                    yScale: strYScale.trim() == "" ? null : Number(strYScale),
                    xScale: strXScale.trim() == "" ? null : Number(strXScale),
                    yMax: strYMax.trim() == "" ? null : Number(strYMax),
                    yMin: strYMin.trim() == "" ? null : Number(strYMin),
                    xRange: strXRange.trim() == "" ? null : Number(strXRange),
                },
                "mail": {
                    "isSend": isSend,
                    "sendSpan": sendSpan
                },
                "comment": comment
            };
            if (sensorKind == 1) {
                params.waterConfig = {
                    "isAdCalc": isAdCalc,
                    "minAnalog": minAnalog,
                    "maxAnalog": maxAnalog,
                    "minDigital": minDigital,
                    "maxDigital": maxDigital
                };
            }

            const token = cookies.access_token || "";
            await ApiRequest.registSensorSetting(params, token, (response: any) => {
                setError(response.data.messsages);
                if (Array.isArray(response.data)) {
                    setSensorSettingData(response.data);
                }
                if (response.data.result === 0) {
                    handleClose();
                }
                props.setState(" ");
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    return (
        <div>
            <button onClick={handleOpen} className="btn btn-blue-line"><i className="icon-edit-b"></i>編集</button>
            <Modal {...modalProps} open={open} onClose={handleClose}>
                <div className="modal-wrapper"
                    // style={{ display: "none" }}
                    id="modal-message">

                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                センサ設定編集
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>
                        <div className="modal-body">
                            <div className="edit-box">
                                {
                                    error && error.length > 0 ?
                                        <ul className="error-box">
                                            {error.map((err, index) => <li key={index}>{err}</li>)}
                                        </ul>
                                        : null
                                }

                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">センサ管理番号
                                        {/*<span className="required"></span>*/}
                                    </div>
                                    <div className="edit-box-elm-input">
                                        <input
                                            type="text"
                                            value={sensorId}
                                            id=""
                                            name=""
                                            className="col-320"
                                            disabled={true}
                                        // onChange={(e) => setSensorId(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {/* センサ名入力 */}
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-input">
                                        <div className="edit-box-elm">
                                            <div className="edit-box-elm-name">センサ名</div>
                                            <div className="edit-box-elm-input">
                                                <input
                                                    type="text"
                                                    value={sensorName}
                                                    id=""
                                                    name=""
                                                    className="col-320"
                                                    onChange={(e) => setSensorName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* 項目 */}
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-input">
                                        <div className="edit-box-elm">
                                            <div className="edit-box-elm-name">項目</div>
                                            <div className="edit-box-elm-input">
                                                <select
                                                    value={childKind}
                                                    className="col-320"
                                                    onChange={(e) => setChildKind(Number(e.target.value))}
                                                    disabled
                                                >
                                                    {sensorKind === 1 && (
                                                        <>
                                                            <option value="1">水位</option>
                                                        </>
                                                    )}
                                                    {sensorKind === 2 && (
                                                        <>
                                                            <option value="3">温度</option>
                                                            <option value="4">湿度</option>
                                                            <option value="2">風速</option>
                                                            <option value="1">風向</option>
                                                            <option value="5">雨量</option>
                                                            <option value="6">WBGT</option>
                                                        </>
                                                    )}
                                                    {sensorKind === 3 && (
                                                        <>
                                                            <option value="1">騒音</option>
                                                            <option value="2">振動</option>
                                                        </>
                                                    )}

                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* 計測値変換 */}

                                {sensorKind == 1 ?
                                    (<div className="edit-box-elm">
                                        <div className="edit-box-elm-name">計測値変換
                                            <span className="required2"></span>
                                        </div>
                                        <div className="edit-box-elm-input">
                                            <span>下限</span>
                                            <input
                                                type="text"
                                                value={minDigital}
                                                id=""
                                                name=""
                                                className="col-80"
                                                onChange={(e) => setMinDigital(e.target.value)}
                                            />
                                            <span>m</span>
                                            <input
                                                type="text"
                                                id=""
                                                value={minAnalog}
                                                name=""
                                                className="col-80"
                                                onChange={(e) => setMinAnalog(e.target.value)}
                                            />
                                            <span>mA</span>
                                            <span className="ml-10">上限</span>
                                            <input
                                                type="text"
                                                value={maxDigital}
                                                id=""
                                                name=""
                                                className="col-80"
                                                onChange={(e) => setMaxDigital(e.target.value)}
                                            />
                                            <span>m</span>
                                            <input
                                                type="text"
                                                value={maxAnalog}
                                                id=""
                                                name=""
                                                className="col-80"
                                                onChange={(e) => setMaxAnalog(e.target.value)}
                                            />
                                            <span>mA</span>
                                        </div>
                                    </div>) : (<></>)}

                                {/* 閾値 */}
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">閾値
                                        <span className="required"></span>
                                    </div>
                                    {sensorKind === 2 && childKind === 6 ? (
                                        <div className="edit-box-elm-input">
                                            <span className="ml-10">1次上限値</span>
                                                <select
                                                    value={wbgtStatusId}
                                                    className="col-160"
                                                    onChange={(e) => updateWbgtStatusId(Number(e.target.value))}
                                                >
                                                    <option value="0">選択なし</option>
                                                    <option value="1">危険</option>
                                                    <option value="2">厳重警戒</option>
                                                    <option value="3">警戒</option>
                                                    <option value="4">注意</option>
                                                    <option value="5">警報なし</option>
                                                </select>

                                                <input
                                                    type="hidden"
                                                    value={strUpThrehold}
                                                    id="" name=""
                                                    className="col-160"
                                                    onChange={(e) => setStrUpThrehold((e.target.value))}
                                                />

                                            <span className="ml-10">2次上限値</span>
                                                <select
                                                    value={wbgtStatusId2}
                                                    className="col-160"
                                                    onChange={(e) => updateWbgtStatusId2(Number(e.target.value))}
                                                >
                                                    <option value="0">選択なし</option>
                                                    <option value="1">危険</option>
                                                    <option value="2">厳重警戒</option>
                                                    <option value="3">警戒</option>
                                                    <option value="4">注意</option>
                                                    <option value="5">警報なし</option>
                                                </select>

                                                <input
                                                    type="hidden"
                                                    value={strUpupThrehold}
                                                    id=""
                                                    name=""
                                                    className="col-160"
                                                    onChange={(e) => setStrUpupThrehold((e.target.value))}
                                                />

                                        </div>) : (<></>)}
                                    {sensorKind !== 2 || sensorKind === 2 && childKind !== 6 ? (
                                        <>
                                        <div className="edit-box-elm-input">
                                            <span className="ml-10">1次上限値</span>
                                            <input
                                                type="text"
                                                value={strUpThrehold}
                                                id="" name=""
                                                className="col-160"
                                                onChange={(e) => setStrUpThrehold((e.target.value))}
                                            />
                                            <span className="ml-10">2次上限値</span>
                                            <input
                                                type="text"
                                                value={strUpupThrehold}
                                                id=""
                                                name=""
                                                className="col-160"
                                                onChange={(e) => setStrUpupThrehold((e.target.value))}
                                            />
                                        </div>
                                        <div className="edit-box-elm-input">
                                            <span className="ml-10">1次下限値</span>
                                            <input
                                                type="text"
                                                value={strLowThrehold}
                                                id="" name=""
                                                className="col-160"
                                                onChange={(e) => setStrLowThrehold((e.target.value))}
                                            />
                                            <span className="ml-10">2次下限値</span>
                                            <input
                                                type="text"
                                                value={strLowlowThrehold}
                                                id=""
                                                name=""
                                                className="col-160"
                                                onChange={(e) => setStrLowlowThrehold((e.target.value))}
                                            />
                                        </div>
                                        </>
                                        ) : (<></>)}
                                    {sensorKind === 2 && childKind === 6 ? (
                                        <>
                                        <div className="edit-box-elm-input">
                                            <div className="edit-box-elm-name">
                                                <span className="ml-10">　　　【暑さ指数指針】</span>
                                                <div className="edit-box-elm-input">　　　　　　　 31 以上　危険</div>
                                                <div className="edit-box-elm-input">　　　28 以上－31 未満　厳重警戒</div>
                                                <div className="edit-box-elm-input">　　　25 以上－28 未満　警戒</div>
                                                <div className="edit-box-elm-input">　　　21 以上－25 未満　注意</div>
                                                <div className="edit-box-elm-input">　　　21 未満　　 　　　ほぼ安全</div>
                                                <div className="edit-box-elm-input">&nbsp;</div>
                                                <div className="edit-box-elm-input">　　　<a href="https://www.wbgt.env.go.jp/wbgt_detail.php" target="_blank">参照：https://www.wbgt.env.go.jp/wbgt_detail.php</a></div>
                                            </div>
                                        </div>
                                        </>
                                    ) : (<></>)}
                                </div>

                                {/* グラフスケール  */}
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">グラフスケール
                                        <span className="required"></span>
                                    </div>
                                    <div className="edit-box-elm-input">
                                        <span>縦軸</span>
                                        <input
                                            type="text"
                                            value={strYMin || ""}
                                            id=""
                                            name=""
                                            className="col-80"
                                            onChange={(e) => setStrYMin((e.target.value))}
                                        /> {props.item.childUnit}
                                        <span>〜</span>
                                        <input
                                            type="text"
                                            value={strYMax}
                                            id=""
                                            name=""
                                            className="col-80"
                                            onChange={(e) => setStrYMax((e.target.value))}
                                        /> {props.item.childUnit}
                                        <span className="ml-10">目盛り間隔</span>
                                        <input
                                            type="text"
                                            value={strYScale}
                                            id=""
                                            name=""
                                            className="col-80"
                                            onChange={(e) => setStrYScale((e.target.value))}
                                        />
                                    </div>
                                    <div className="edit-box-elm-input">
                                        <span>横軸</span>
                                        <input
                                            type="text"
                                            value={strXRange}
                                            id=""
                                            name=""
                                            className="col-80"
                                            onChange={(e) => setStrXRange((e.target.value))}
                                        />
                                        <span>日間</span>
                                        <span className="ml-10">目盛り間隔</span>
                                        <input
                                            type="text"
                                            value={strXScale}
                                            id=""
                                            name=""
                                            className="col-80"
                                            onChange={(e) => setStrXScale((e.target.value))}
                                        />
                                        <span>日</span>
                                    </div>
                                </div>

                                {/*メール送信有無  */}
                                <div className="edit-box-elm-name">メール送信有無
                                </div>
                                <div className="edit-box-elm-input">
                                    <input
                                        type="radio"
                                        id="r1"
                                        name="rr"
                                        checked={!isSend}
                                        onChange={() => setIsSend(false)}
                                    />
                                    <label htmlFor="r1">なし</label>
                                    <input
                                        type="radio"
                                        id="r2"
                                        name="rr"
                                        checked={isSend}
                                        onChange={() => setIsSend(true)}
                                    />
                                    <label htmlFor="r2">あり</label>
                                </div>
                                {/* メール送信間隔（分） */}
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">メール送信間隔（分）
                                        <span className="required"></span>
                                    </div>
                                    <div className="edit-box-elm-input">
                                        <input
                                            type="text"
                                            value={sendSpan}
                                            id=""
                                            name=""
                                            className="col-320"
                                            onChange={(e) => setSendSpan(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* メモ */}
                                <div className="edit-box-elm">
                                    <div className="edit-box-elm-name">メモ</div>
                                    <div className="edit-box-elm-input">
                                        <textarea name="kansou"
                                            value={comment}
                                            rows={3}
                                            cols={40}
                                            className="col-100p"
                                            onChange={(e) => setComment(e.target.value)}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <div className="model-action-sub">
                                {/* <SensorSettingModalDelete
                                sensorRecno={sensorRecno}
                                /> */}
                            </div>
                            <div className="model-action-main">
                                <button onClick={handleClose} className="btn btn-blue-line">
                                    キャンセル
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-blue col-160">
                                        <i className="icon-check-w"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >
        </div >
    );
}
